import api from '@/js/services/api';
export default {
    getNotifications(user_id, filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get(`/master-admin/${user_id}/notifications/get?` + searchParams.toString())
    },

    getUnreadNotifications(user_id) {
        return api().get(`/master-admin/${user_id}/notifications/unread/get`)
    },

    readMessages(user_id) {
        return api().post(`/master-admin/${user_id}/notifications/mark-as-read`)
    }






}
